import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DripsRegular from './drips-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DripsRegular {...validProps} />;
}

SvgComponent.iconName = 'dripsRegular';

export const DripsRegularIcon = svgIconWrapper(SvgComponent);
